import { JobType } from "@/core/api/apiClient";

const mapping: Record<JobType, string> = {
  Sling: "Sling",
  Dump: "Dump",
  Pump: "Pump"
};

export function mapJobType(key: JobType | string): string {
  return mapping[key as JobType] ?? key;
}

export default mapJobType;
